export const TITLETEXT_PROPS = {
  ALIGNMENT: "alignment",
  LAYOUT: "layout",
  ICON_SIZE: "iconSize",
  OVERLINE_SIZE: "overlineSize",
  TITLE_SIZE: "titleSize",
  TEXT_SIZE: "textSize",
  LINE_WIDTH: "lineWidth",
  LINE_WEIGHT: "lineWeight",
  ICON: "titleIcon",
  EMOJI: "emoji",
  EMOJI_ENABLED: "emojiEnabled",
  OVERLINE_COLOR: "overlineColor",
  TITLE_COLOR: "titleColor",
  TEXT_COLOR: "textColor",
  LINE_COLOR: "lineColor",
  ICON_COLOR: "iconColor",
  OVERLINE: "overline",
  TITLE: "title",
  TEXT: "text",
  ACTIVE_COLORS_BY_COLOR_SCHEME: "activeColorsByColorScheme",
  COLORS_BY_COLOR_SCHEME: "colorsByColorScheme",
};

export const LAYOUT_PROPS = {
  OVERLINE: "overline",
  TITLE: "title",
  TEXT: "text",
  LINE: "line",
  ICON: "icon",
};

export const ICON_PROP = {
  emoji: TITLETEXT_PROPS.EMOJI,
  icon: TITLETEXT_PROPS.ICON,
};
